export var UNICODE_EXTENSION_SEQUENCE_REGEX = /-u(?:-[0-9a-z]{2,8})+/gi;
export function invariant(condition, message, Err) {
    if (Err === void 0) { Err = Error; }
    if (!condition) {
        throw new Err(message);
    }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formatjs/intl-localematcher/lib/abstract/utils.js
// module id = 190
// module chunks = 7